import React from "react";
import classNames from "classnames/bind";

import { useStateManager } from "utils/useStateManager";
import logo_small from "../../icons/logo_small.svg";

import styles from "./Footer.module.css";

const cx = classNames.bind(styles);

type Props = {
  label?: React.ReactNode;
};

export const Footer: React.FC<Props> = ({ label }) => {
  const { linkInfo } = useStateManager();
  const logo = {
    src: logo_small,
    width: 24,
    height: 24,
  };
  let text = process.env.REACT_APP_API === "dd" ? "Доступная Диетология" : "Nutrilogic";

  if (linkInfo?.custom?.custom_additional_data?.logo) {
    logo.src = linkInfo?.custom?.custom_additional_data?.logo;
  }

  if (linkInfo?.custom?.custom_additional_data?.logo_final_size) {
    const [width, height] = linkInfo?.custom?.custom_additional_data?.logo_final_size.split("x");
    logo.width = +width;
    logo.height = +height;
  }

  if (linkInfo?.custom?.custom_additional_data?.replacement_footer_copyright === null) {
    text = "";
  } else if (linkInfo?.custom?.custom_additional_data?.replacement_footer_copyright) {
    text = linkInfo?.custom?.custom_additional_data.replacement_footer_copyright;
  }

  return (
    <div className={cx("footer")}>
      {label && <span className={cx("footerLabel")}>{label}</span>}
      <div className={cx("footerLogo")}>
        <img src={logo.src} width={logo.width} height={logo.height} alt="Nutrilogic" />
      </div>
      <span className={cx("footerText")}>
        {text && `${text}, ${new Date().getFullYear()}`}
      </span>
    </div>
  );
};
